<template>
  <div id="assign-visit">
    <v-text-field
      v-model="search"
      prepend-icon="search"
      label="Search"
      placeholder="Search by AssignTo/From/Company"
      clearable
      single-line
      hide-details/>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="720px">
      <template v-slot:activator="{ on }">
        <v-btn
          color="general"
          class="mb-2"
          dark
          v-on="on">New
        </v-btn>
      </template>
      <v-form
        id="form1-vue"
        ref="form1"
        v-model="valid1"
        :lazy-validation="lazyValidation1"
      >
        <v-card>
          <v-chip
            label
            color="general"
            text-color="white">
            <v-icon left>label</v-icon>
            {{ visitType }} Visit
          </v-chip>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  md3>
                  <v-autocomplete
                    v-model="editedItem.visit.customer.company.id"
                    :items="companies"
                    :rules="[rules.required]"
                    :search-input.sync="searchCompany"
                    hide-no-data
                    placeholder="type 3 words to search..."
                    label="Company *"
                    item-text="name"
                    item-value="id"
                    required
                    @input="onSelectCompany"
                  />
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-select
                    v-show="showCustomerSelect"
                    :items="customers"
                    v-model="editedItem.visit.customer"
                    :rules="[rules.required]"
                    menu-props="auto"
                    item-text="name"
                    item-value="id"
                    required
                    label="Customer *"
                    return-object
                    placeholder="Select Customer"
                    hint="Select Company First"
                    @input="getShodans"
                  />
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-select
                    v-if="visitType === 'SALES'"
                    v-show="showShodanSelect"
                    v-model="editedItem.visit.shodan"
                    :items="shodans"
                    menu-props="auto"
                    item-text="name"
                    item-value="id"
                    label="Shodan"
                    return-object
                    placeholder="Select..."
                  />
                  <v-select
                    v-else
                    v-model="editedItem.visit.project"
                    :items="projects"
                    menu-props="auto"
                    item-text="refNo"
                    item-value="id"
                    label="Project"
                    return-object
                    placeholder="Select..."
                  />
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :rules="[rules.required]"
                        :value="computedDateFormatted"
                        label="Visit Date *"
                        hint="DD/MM/YYYY"
                        required
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.visit.visitDate"
                      no-title
                      @input="menu2 = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.visit.timeStart"
                    :rules="[rules.number,rules.time,rules.required]"
                    label="Time Start *"
                    mask="time"
                    prepend-icon="mdi-timetable"
                    required
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.visit.timeEnd"
                    :rules="[rules.number,rules.time,rules.required]"
                    label="Time End *"
                    mask="time"
                    prepend-icon="mdi-timetable"
                    required
                    class="blue-input"/>
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-select
                    v-model="editedItem.to"
                    :items="userLogins"
                    :rules="[rules.required]"
                    menu-props="auto"
                    item-text="username"
                    item-value="id"
                    label="Assign To"
                    required
                    return-object
                    placeholder="Select..."
                  />
                </v-flex>
                <v-flex
                  xs6
                  md4
                >
                  <v-select
                    v-model="editedItem.from"
                    :items="userLogins"
                    :rules="[rules.required]"
                    menu-props="auto"
                    item-text="username"
                    item-value="id"
                    label="Assign From"
                    required
                    return-object
                    placeholder="Select..."
                  />
                </v-flex>

                <v-flex
                  xs12
                  md8
                >
                  <v-textarea
                    v-model="editedItem.visit.activity"
                    :rules="[rules.required]"
                    label="Activiy Detail *"
                    counter
                    required
                    clearable
                    class="blue-input"
                  />
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="red darken-1"
              flat
              @click="close">Cancel
            </v-btn>
            <v-btn
              :disabled="!valid1"
              flat
              color="green darken-1"
              @click="saveAssignVisit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="DataList"
      :rows-per-page-items="rowsAmount"
      :total-items="totalRows"
      :search="search"
      dense
      loading-text="Loading... Please wait"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <!--        <td class="justify-center ">-->
        <!--          <v-icon-->
        <!--            medium-->
        <!--            class="mr-2"-->
        <!--            @click.stop="editItem(props.item)">edit</v-icon>-->
        <!--          <v-icon-->
        <!--            medium-->
        <!--            @click.stop="dialogDeleteShow(props.item)">delete-->
        <!--          </v-icon>-->
        <!--        </td>-->
        <td>{{ props.item.visit.visitDate }}</td>
        <td class="">{{ toTimeFormat(props.item.visit.timeStart) }}</td>
        <td class="">{{ toTimeFormat(props.item.visit.timeEnd) }}</td>
        <td>{{ props.item.to.username }}</td>
        <td>{{ props.item.from.username }}</td>
        <td>{{ props.item.visit.customer.company.name }}</td>
        <td>{{ props.item.visit.customer.name }}</td>
        <td>{{ props.item.visit.activity }}</td>
        <td>{{ showShodanOrProject(props.item.visit) }}</td>
        <td>{{ props.item.createdBy }}</td>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogDelete"
      max-width="400px">
      <v-card>
        <v-card-title class="headline">System Message Confirmation</v-card-title>
        <v-card-text>
          Are you sure want to remove this record? <br>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="red darken-1"
            text
            flat
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            flat
            @click="deleteItem(deleteItemRecord)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-icon
        size="16"
        @click="snack = false"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </div>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'

  export default {
    name: 'AssignVisit',
    mixins: [displayFormatterMixins],
    props: {
      visitType: String
    },
    data: () => ({
      menu: false,
      snack: false,
      snackText: '',
      snackColor: '',
      valid1: false,
      lazyValidation1: false,
      showCustomerSelect: false,
      showShodanSelect: false,
      typeVisit: ['PROJECT', 'SALES'],
      editedIndex: -1,
      editedItem: {
        id: null,
        to: {
          id: null,
          username: '',
          employee: {
            firstName: '',
            lastName: ''
          }
        },
        from: {
          id: null,
          username: '',
          employee: {
            firstName: '',
            lastName: ''
          }
        },
        visit: {
          id: null,
          activity: '',
          type: '',
          status: 'DRAFT',
          visitDate: '',
          timeStart: '',
          timeEnd: '',
          customer: {
            id: null,
            name: '',
            company: {
              id: null,
              name: ''
            }
          },
          shodan: {
            id: null,
            name: ''
          },
          project: {
            id: null,
            refNo: ''
          }
        }
      },
      defaultItem: {
        id: null,
        to: {
          id: null,
          username: '',
          employee: {
            firstName: '',
            lastName: ''
          }
        },
        from: {
          id: null,
          username: '',
          employee: {
            firstName: '',
            lastName: ''
          }
        },
        visit: {
          id: null,
          activity: '',
          type: '',
          status: 'DRAFT',
          visitDate: '',
          timeStart: '',
          timeEnd: '',
          customer: {
            id: null,
            name: '',
            company: {
              id: null,
              name: ''
            }
          },
          shodan: {
            id: null,
            name: ''
          },
          project: {
            id: null,
            refNo: ''
          }
        }
      },

      rules: {
        required: value => !!value || 'Required',
        number: value => !isNaN(value) || 'Must be numeric',
        time: value => {
          // ignore `:` masked already
          const pattern = /^([0-1]?[0-9]|2[0-4])([0-5][0-9])(:[0-5][0-9])?$/
          return !value || pattern.test(value) || 'Invalid 24h time format'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
      },
      companies: [],
      customers: [],
      projects: [],
      shodans: [],
      userLogins: [],
      pagination: {},
      DataList: [],
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      dialog: false,
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      headers: [
        // { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Visit Date', value: 'visit.visitDate' },
        { text: 'Time Start', value: 'visit.timeStart' },
        { text: 'Time End', value: 'visit.timeEnd' },
        { text: 'Assign To', value: 'to.username' },
        { text: 'Assign From', value: 'from.username' },
        { text: 'Company', value: 'visit.customer.company.name' },
        { text: 'Customer', value: 'visit.customer.company.customer.name' },
        { text: 'Activity', value: 'visit.activity' },
        { text: `Shodan/Project`, value: 'visit.project.refNo', sortable: false },
        { text: 'Created By', value: 'createdBy' }
      ],
      searchCompany: ''
    }),
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.editedItem.visit.visitDate)
      }
    },
    watch: {
      searchCompany () {
        if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
    },
    created () {
      // this.debouncedGetData = _.debounce(this.getVisit, 500)
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
      // this.getCompanies()
      this.getShodans()
      this.getProjects(
        this.getDatatable())
      this.getUserLogins()
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      // async getVisit () {
      //   try {
      //     this.loading = true
      //     const { sortBy, descending, page, rowsPerPage } = this.pagination
      //     let q = this.search || ''
      //     console.debug(this.pagination)
      //     let pageNoXHR = page - 1
      //     let response = await this.$http.get(`/api/visit?vt=${this.visitType}&ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'visitDate'}&dc=${descending || false}&q=${q}`)
      //
      //     this.loading = false
      //     this.DataList = response.data.content
      //     this.totalRows = response.data.totalElements
      //   } catch (error) {
      //     console.log(error)
      //   }
      // },
      async getDatatable () {
        try {
          let response = await this.$http.get(`/api/assignv?type=${this.visitType}`) // not a paging response
          console.log(response.data)
          this.DataList = response.data
          this.totalRows = response.data.length
        } catch (error) {
          console.log(error)
        }
      },
      async onSelectCompany() {
        this.getCustomers()
        this.getProjects()
      },
      async getCustomers () {
        try {
          let response = await this.$http.get(`/api/customer/select?companyId=${this.editedItem.visit.customer.company.id}`)
          this.customers = response.data
          let custobj = _.find(this.customers, ['id', this.editedItem.visit.customer.id])
          this.editedItem.customerSelect = custobj || ''
          this.showCustomerSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getShodans () {
        try {
          let response = await this.$http.get(`/api/shodan/select?status=OPEN&cid=${this.editedItem.visit.customer.id || ''}`)
          this.shodans = response.data
          this.showShodanSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getProjects () {
        try {
          let response = await this.$http.get(`/api/project/select?companyid=${this.editedItem.visit.customer.company.id}`)
          this.projects = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select`)
          this.userLogins = response.data
        } catch (error) {
          console.log(error)
        }
      },
      reset () { // seems not used
        this.$refs.form1.resetValidation()
        this.resetInline()
        this.date = ''
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = _.cloneDeep(this.defaultItem)
        this.showShodanSelect = false
        this.showCustomerSelect = false
      },
      close () {
        this.dialog = false
        this.$refs.form1.resetValidation()
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.showCustomerSelect = false
          this.showShodanSelect = false
          this.date = ''
          this.editedIndex = -1
        }, 300)
      },
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        console.log('edit')
        console.log(item)
        this.editedItem = Object.assign({}, item)
        this.getCustomers() // populate during edit
        this.getShodans()
        this.dialog = dbox
      },
      async deleteItem (rec) {
        this.dialogDelete = false
        let endpoint = `api/assignv/${rec.id}`
        let method = 'delete'
        let s = {}
        try {
          let response = await this.$store.dispatch('updateTableItem', { endpoint, s, method })
          if (response) {
            this.DataList.splice(this.DataList.indexOf(rec), 1)
            this.deleteInline()
          } else {
            this.cancelInline()
          }
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      async saveAssignVisit () {
        if (!this.$refs.form1.validate()) {
          console.log('validation fail direct')
          return false
        }
        this.editedItem.visit.type = this.visitType
        let tableItem = this.editedItem
        tableItem.customer = this.editedItem.customerSelect
        // this.editedItem.company.name = _.find(this.companies, { 'id': this.editedItem.customer.company.id }).name
        // this.editedItem.customer.name = _.find(this.customers, { 'id': this.editedItem.customer.id }).name

        if (this.editedIndex > -1) {
          let endpoint = `api/assignv/${this.editedItem.id}`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            Object.assign(this.DataList[this.editedIndex], this.editedItem)
            this.saveInline()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        } else {
          let endpoint = `api/assignv`
          let method = 'post'
          try {
            let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            // this.$store.dispatch('syncNotification')
            console.log(resp)
            this.saveInline()
            this.getDatatable()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        }
        this.close()
      },
      showShodanOrProject (obj) {
        if (obj.type === 'PROJECT') {
          if (!_.isEmpty(obj.project) && !_.isEmpty(obj.project.refNo)) {
            return obj.project.refNo
          }
        } else {
          if (!_.isEmpty(obj.shodan) && !_.isEmpty(obj.shodan.name)) {
            return obj.shodan.name
          }
        }
        return 'N'
      },
      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      resetInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      }
    }

  }
</script>

<style scoped>

</style>
